import React from 'react';
// import { Redirect } from "react-router-dom";
// import Cookies from 'js-cookie';
import Highlighter from 'react-highlight-words';
// import { Link } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Input,
	Button,
	Table,
	Modal,
	message,
	Alert,
	Tag,
	Tooltip,
	Typography,
	Pagination,
	Form,
	DatePicker
} from 'antd';
import moment from 'moment';
import {
	SearchOutlined,
	ExclamationCircleOutlined,
	RedoOutlined,
	CheckCircleOutlined,
	InfoCircleOutlined,
	SplitCellsOutlined,
	CloseCircleOutlined,
	CloseOutlined,
	IdcardOutlined,
	UserOutlined,
} from '@ant-design/icons';

// import axios from 'axios';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const FIELD_STYLE = {
	borderRadius: 8,
};

const configClass = {
	title: 'data migrasi',
	apiUrl: {
		data: 'kendaraan/api/migrasi/',

	},
	breadCrumb: [
		(
			<span>
				<InfoCircleOutlined /> informasi
			</span>
		),
		'migrasi'
	]

}

const config = new Config();

class DataMigrasi extends React.Component {
	formRefOveride = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			isModalKoreksi: false,
			isModalHasil: false,
			hasilMigrasi: { success: true, message: '' },
			modifiedField: {},
			nomor_polisi: "",
			errMsg: '',
			loadingData: false,
			isMobile: window.innerWidth <= 768,
			pagination: { pageSize: 25, current: 1 },
			searchText: '',
			searchColumn: '',
			dataSource: [],
			columns: [
				{
					title: 'NIK',
					width: 150,
					dataIndex: 'pemilik_nik',
					key: 'pemilik_nik'
				},
				{
					title: 'NAMA',
					width: 150,
					dataIndex: 'nama_wp',
					key: 'nama_wp'
				},
				{
					title: 'TGL TERAKHIR BAYAR',
					width: 150,
					dataIndex: 'sd_notice',
					key: 'sd_notice'
				},
				{
					title: 'STNK AKHIR',
					width: 150,
					dataIndex: 'stnk_akhir',
					key: 'stnk_akhir'
				},
				{
					title: 'ALAMAT WP',
					width: 150,
					dataIndex: 'alamat_wp',
					key: 'alamat_wp'
				},
				{
					title: 'PEMILIK',
					width: 150,
					dataIndex: 'pemilik_nama',
					key: 'pemilik_nama'
				},
				{
					title: 'NO HP',
					width: 150,
					dataIndex: 'pemilik_no_hp',
					key: 'pemilik_no_hp'
				},
				{
					title: 'NOMOR MESIN',
					width: 150,
					dataIndex: 'nomor_mesin',
					key: 'nomor_mesin'
				},
				{
					title: 'TAHUN BUAT',
					width: 150,
					dataIndex: 'tahun_buat',
					key: 'tahun_buat'
				},
				{
					title: 'AKSI',
					width: 90,
					dataIndex: 'id',
					key: 'aksi',
					fixed: 'right',
					align: 'center',
					render: (value, row) => {
						return (
							<Tooltip title="Proses Migrasi">
								<Button size="small" shape="circle" type="primary" ghost onClick={() => this.showPilihConfirm(row)}>
									<SplitCellsOutlined />
								</Button>
							</Tooltip>
						)
					},
				}

			]
		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus?',
			icon: <ExclamationCircleOutlined />,
			content: 'yakin menghapus data?',
			okText: 'Ya',
			okType: 'danger',
			cancelText: 'Tidak',
			centered: true,
			onOk: () => this.prosesHapus(id),
			onCancel() {
				//console.log('Cancel');
			},
		});
	}

	checkValidDate(dateValue) {
		const dateRegex = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
		const dateTimeRegex = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
		let result = false;
		if (dateRegex.test(dateValue)) {
			if (dateValue == "0000-00-00") {
				result = false;
			} else {
				result = true;
			}
		} else if (dateTimeRegex.test(dateValue)) {
			if (dateValue == "0000-00-00 00:00:00") {
				result = false;
			} else {
				result = true;
			}
		}
		return result;
	}

	showPilihConfirm(data) {
		const forCheck = ["sd_notice", "stnk_akhir", "sd_swdkllj","pembayaran_terakhir"];
		let tempForEdit = {};
		Object.entries(data).forEach(([key, value]) => {
			if (forCheck.includes(key)) {
				// if (this.checkValidDate(value) == false) {//jika mau pengecekan format harus valid baru muncul popoup
				// alert(key+": "+forCheck.includes(key)+"="+value)
				tempForEdit = { ...tempForEdit, [key]: value }
				// }
			}
		})
		// alert(JSON.stringify(tempForEdit))
		if (Object.keys(tempForEdit).length > 0) {
			this.setState({
				isModalKoreksi: true,
				modifiedField: tempForEdit,
				nomor_polisi: data.nomor_polisi
			}, () => {
				// alert(JSON.stringify(this.state.modifiedField))
				setTimeout(() => {
					Object.entries(data).forEach(([key, value]) => {
						if (forCheck.includes(key)) {
							if (this.checkValidDate(value)) {//pengecekan format valid set datepicker
								// alert(key+": "+forCheck.includes(key)+"="+value)
								this.formRefOveride.current.setFieldsValue({
									[key+"_picker"]: moment(value),
									[key]: value
								})
							}else{
								this.formRefOveride.current.setFieldsValue({
									[key+"_picker"]: undefined,
									[key]: ""
								})
							}
						}
					})
				}, 500)
			})
		} else {
			Modal.confirm({
				title: 'Konfirmasi Proses Migrasi?',
				icon: <ExclamationCircleOutlined />,
				content: 'yakin memproses migrasi?',
				okText: 'Ya',
				okType: 'danger',
				cancelText: 'Tidak',
				centered: true,
				onOk: () => this.prosesPilih(data),
				onCancel() {
					//console.log('Cancel');
				},
			});
		}
	}

	prosesHapus(id) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({
					loadingButton: false
				});
				if (this.props.isSuccess) {
					message.success({ content: 'berhasil menghapus data', duration: 2, key: 'toast' });
					this.getData();
				} else {
					const errTitle = 'gagal menghapus data'
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
				}
			}).catch((response) => {
				console.log('gagal_delete', response);
				this.setState({
					loadingButton: false
				});
				message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	prosesPilih(data) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler('get', configClass.apiUrl.data + data.id + '/migrate/')
			.then(() => {
				message.destroy('toast');
				this.setState({
					loadingButton: false
				});
				if (this.props.isSuccess) {
					const resp = this.props.responseMsg || {};
					this.setState({
						isModalHasil: true,
						hasilMigrasi: { success: true, message: resp.message || resp.status || 'Migrasi berhasil diproses.' }
					});
					this.getData();
				} else {
					const resp = this.props.responseMsg;
					this.setState({
						isModalHasil: true,
						hasilMigrasi: { success: false, message: (resp && (resp.message || resp.status)) || 'Gagal memproses migrasi.' }
					});
				}
			}).catch((response) => {
				console.log('gagal_delete', response);
				message.destroy('toast');
				this.setState({
					loadingButton: false,
					isModalHasil: true,
					hasilMigrasi: { success: false, message: 'Kesalahan pengiriman data, coba lagi.' }
				});
			});
	}

	getColumnSearchProps = dataIndex => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={node => {
						this.searchInput = node;
					}}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					icon={<SearchOutlined />}
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>
					Search
				</Button>
				<Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
					Reset
				</Button>
			</div>
		),
		filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
		onFilter: (value, record) =>
			record[dataIndex]
				.toString()
				.toLowerCase()
				.includes(value.toLowerCase()),
		onFilterDropdownVisibleChange: visible => {
			if (visible) {
				setTimeout(() => this.searchInput.select());
			}
		},
		render: text =>
			this.state.searchedColumn == dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[this.state.searchText]}
					autoEscape
					textToHighlight={text.toString()}
				/>
			) : (
				text
			),
	});

	handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		this.setState({
			searchText: selectedKeys[0],
			searchedColumn: dataIndex,
		});
	};

	handleReset = clearFilters => {
		clearFilters();
		this.setState({ searchText: '' });
	};

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		//console.log('master/api/desa/?limit='+limit+'&offset='+offset);

		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					const pagination = { ...this.state.pagination };
					pagination.total = data.count;
					this.setState({
						dataSource: data.results,
						pagination
					});
				} else {
					const errTitle = 'error get data';
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			}).catch((response) => {
				console.log('gagal_get_preview', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	async getProfile() {
		this.props.ajaxViewHandler('get', configClass.apiUrl.userProfile)
			.then(() => {
				const data = this.props.responseMsg;
				// console.log('data_profile', data);
				if (data != undefined) {
					this.props.setConfig({
						username: data.username,
						id: data.id,
						// pp: this.config.get_site_info().logo,
						nama: data.pegawai[0].nama,
						akses: data.access,
						printer: data.pegawai[0].serial_printer != undefined ? data.pegawai[0].serial_printer : "pengaturan printer belum dipilih",
						nama_printer: data.pegawai[0].nama_printer != undefined ? data.pegawai[0].nama_printer : "pengaturan printer belum dipilih",
					});

					// askForPermissioToReceiveNotifications(data[0].tempatTugas);

					// if(!this.props.switchable){
					// 	// this.props.setConfig({
					// 	// 	isSuperadmin: data[0].is_superuser
					// 	// });
					// }
				}
			}).catch((response) => {
				console.log('gagal_getprofile', response);
				message.error({ content: 'gagal request data profile, coba lagi', key: 'toast' });
			});
	}

	handleTableChange = async (pagination, filters, sorter) => {
		const newPagination = { ...this.state.pagination };
		newPagination.pageSize = pagination.pageSize;
		this.setState({
			loadingData: true,
			pagination
		});
		if (pagination.current == 1) {
			this.getData(pagination.pageSize);
		} else {
			this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
		}


	}

	handleSubmitOveride = (values) => {
		this.postData(values);
	}

	async postData(datas) {
		this.setState({
			errTitle: "",
			errMsg: "",
			loadingButton: true,
		})
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler("post", configClass.apiUrl.data + this.state.nomor_polisi+"/force_migrate/", datas, false, true)
			.then(() => {
				message.destroy('toast');
				this.setState({
					loadingButton: false
				});
				if (this.props.isSuccess) {
					const resp = this.props.responseMsg || {};
					this.setState({
						isModalKoreksi: false,
						isModalHasil: true,
						hasilMigrasi: { success: true, message: resp.message || resp.status || 'Migrasi berhasil diproses.' }
					}, () => {
						this.getData();
					})
				} else {
					const resp = this.props.responseMsg;
					this.setState({
						isModalHasil: true,
						hasilMigrasi: { success: false, message: (resp && (resp.message || resp.status)) || 'Gagal menyimpan data.' }
					});
				}
			}).catch((response) => {
				console.log('gagal_post', response);
				message.destroy('toast');
				this.setState({
					loadingButton: false,
					isModalHasil: true,
					hasilMigrasi: { success: false, message: 'Kesalahan pengiriman data, coba lagi.' }
				});
			});
	}

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	renderMobileCard(row, index) {
		const { pagination } = this.state;
		const noUrut = (pagination.current - 1) * pagination.pageSize + index + 1;
		return (
			<Card
				key={row.id || index}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 40, height: 40, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<UserOutlined style={{ color: '#fff', fontSize: 18 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', lineHeight: 1.3 }}>
							{row.nama_wp || '—'}
						</div>
						<div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>NIK: {row.pemilik_nik || '—'}</div>
					</div>
					<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, fontWeight: 600 }}>#{noUrut}</Tag>
				</div>
				<div style={{ padding: '10px 16px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Tgl Terakhir Bayar</Text>
						<Text style={{ fontSize: 12 }}>{row.sd_notice || '—'}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>STNK Akhir</Text>
						<Text style={{ fontSize: 12 }}>{row.stnk_akhir || '—'}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Pemilik</Text>
						<Text style={{ fontSize: 12 }}>{row.pemilik_nama || '—'}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>No HP</Text>
						<Text style={{ fontSize: 12 }}>{row.pemilik_no_hp || '—'}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>No. Mesin</Text>
						<Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{row.nomor_mesin || '—'}</Text>
					</div>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Tahun Buat</Text>
						<Text style={{ fontSize: 12 }}>{row.tahun_buat || '—'}</Text>
					</div>
					<div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
						<Button block size="small" type="primary" ghost icon={<SplitCellsOutlined />} onClick={() => this.showPilihConfirm(row)}>
							Proses Migrasi
						</Button>
					</div>
				</div>
			</Card>
		);
	}

	renderModalHasil() {
		const { isModalHasil, hasilMigrasi, isMobile } = this.state;
		const sukses = hasilMigrasi.success;
		return (
			<Modal
				visible={isModalHasil}
				footer={null}
				closable={false}
				destroyOnClose
				centered
				width={isMobile ? '90%' : 420}
				className="modal-hasil-migrasi"
				onCancel={() => this.setState({ isModalHasil: false })}
			>
				<div style={{
					background: sukses ? 'linear-gradient(135deg, #0f2847, #1e4d8a)' : 'linear-gradient(135deg, #7f1d1d, #b91c1c)',
					padding: '28px 24px 20px',
					textAlign: 'center',
				}}>
					<div style={{
						width: 64, height: 64, borderRadius: '50%',
						background: 'rgba(255,255,255,0.15)',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
						margin: '0 auto 14px',
					}}>
						{sukses ? (
							<CheckCircleOutlined style={{ color: '#fff', fontSize: 32 }} />
						) : (
							<CloseCircleOutlined style={{ color: '#fff', fontSize: 32 }} />
						)}
					</div>
					<div style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>
						{sukses ? 'Status Migrasi' : 'Migrasi Gagal'}
					</div>
				</div>
				<div style={{ padding: '20px 24px 4px', textAlign: 'center' }}>
					<Text style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap' }}>
						{hasilMigrasi.message}
					</Text>
				</div>
				<div style={{ padding: '20px 24px 24px', display: 'flex', justifyContent: 'center' }}>
					<Button
						type="primary"
						onClick={() => this.setState({ isModalHasil: false })}
						style={{
							borderRadius: 10, minWidth: 130, fontWeight: 600, border: 'none',
							background: sukses ? 'linear-gradient(135deg, #0f2847, #1e4d8a)' : 'linear-gradient(135deg, #7f1d1d, #b91c1c)',
						}}
					>
						Tutup
					</Button>
				</div>
			</Modal>
		);
	}

	render() {
		// if(this.props.isSuperadmin == false){
		// 	return <Redirect to="/admin/forbidden" />
		// }
		const { dataSource, pagination, loadingData, isMobile, searchText } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + " | " + config.get_site_info().name}</title>
					<style>{`
						.data-migrasi-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-migrasi-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-migrasi-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-migrasi-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-migrasi-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
						.form-migrasi-modal .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
							padding: 0;
							box-shadow: 0 12px 40px rgba(15,40,71,0.25);
						}
						.form-migrasi-modal .ant-modal-body { padding: 0; }
						.form-migrasi-modal .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-migrasi-modal .ant-input,
						.form-migrasi-modal .ant-picker {
							border-radius: 8px !important;
						}
						.modal-hasil-migrasi .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
							padding: 0;
							box-shadow: 0 12px 40px rgba(15,40,71,0.25);
						}
						.modal-hasil-migrasi .ant-modal-body { padding: 0; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={this.state.errMsg !== ''}
					title={this.state.errTitle}
					error={this.state.errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-migrasi-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<SplitCellsOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} data perlu dimigrasi
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<Tooltip title="Refresh data">
							<Button
								loading={this.state.loadingButton}
								onClick={() => this.getData()}
								icon={<RedoOutlined />}
								style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
							>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>

					{/* Search bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input.Search
							placeholder="ketikkan pencarian..."
							allowClear
							size="middle"
							style={{ borderRadius: 8, maxWidth: 340 }}
							defaultValue={searchText}
							onSearch={(value) => {
								this.setState({ searchText: value }, () => {
									this.getData();
								});
							}}
						/>
					</div>

					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map((row, idx) => this.renderMobileCard(row, idx))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								bordered
								columns={this.state.columns}
								dataSource={dataSource}
								loading={loadingData}
								rowKey={(row, idx) => row.id || idx}
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									...pagination,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>

				<Modal
					visible={this.state.isModalKoreksi}
					footer={null}
					closable={false}
					destroyOnClose
					width={isMobile ? '94%' : 520}
					className="form-migrasi-modal"
					onCancel={() => this.setState({ isModalKoreksi: false })}
				>
					<Form
						layout="vertical"
						name="fdata"
						onFinish={this.handleSubmitOveride}
						ref={this.formRefOveride}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 48, height: 48, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								<IdcardOutlined style={{ color: '#fff', fontSize: 22 }} />
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
									Koreksi Data Migrasi
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
									Lengkapi tanggal yang belum valid sebelum memproses migrasi
								</div>
							</div>
							<Button shape="circle" icon={<CloseOutlined />} onClick={() => this.setState({ isModalKoreksi: false })}
								style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', flexShrink: 0 }} />
						</div>

						{/* Body */}
						<div style={{ padding: '24px 24px 8px', maxHeight: '65vh', overflowY: 'auto' }}>
							<Row gutter={12}>
								{Object.entries(this.state.modifiedField).map(([key, value]) => (
									<Col span={24} key={"mod" + key}>
										<Form.Item
											label={key.replace(/_/ig, " ")}
											name={key + "_picker"}
											rules={[
												{
													required: true,
													message: 'harus diisi'
												}
											]}
										>
											<DatePicker
												placeholder="dd-mm-yyyy"
												format="YYYY-MM-DD"
												style={{ width: "100%", ...FIELD_STYLE }}
												onChange={(date, dateString) => {
													this.formRefOveride.current.setFieldsValue({
														[key]: dateString,
													});
												}}
											/>
										</Form.Item>
										<Form.Item
											name={key}
											style={{
												display: "none",
											}}
										>
											<Input type="hidden" />
										</Form.Item>
									</Col>
								))}
							</Row>
						</div>

						{/* Footer */}
						<div style={{
							padding: '16px 24px', marginTop: 4, display: 'flex', justifyContent: 'flex-end', gap: 10,
							borderTop: '1px solid #f0f0f0', background: '#fafafa',
						}}>
							<Button
								icon={<CloseCircleOutlined />}
								disabled={this.state.loadingButton ? true : false}
								onClick={() => this.setState({ isModalKoreksi: false })}
								style={{ borderRadius: 10 }}
							>
								Batal
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								loading={this.state.loadingButton}
								disabled={this.state.errComponent ? true : false}
								icon={!this.state.loadingButton && <CheckCircleOutlined />}
								style={{ borderRadius: 10, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', fontWeight: 600 }}
							>
								Simpan
							</Button>
						</div>
					</Form>
				</Modal>

				{this.renderModalHasil()}
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler
	}
)(DataMigrasi);